import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';
import TableCell from 'components/TableCell';

import { ServiceEditVariantsRow_serviceOption$key } from '__generated__/ServiceEditVariantsRow_serviceOption.graphql';

type Props = SortableEntityTableRowProps & {
  serviceOption: ServiceEditVariantsRow_serviceOption$key;
};

const ServiceEditVariantsRow: FC<Props> = props => {
  const serviceOptionData = useFragment(
    graphql`
      fragment ServiceEditVariantsRow_serviceOption on ServiceOption {
        id
        name
        scoroProductId
        price

        ...SortableEntityTableRow_entity
      }
    `,
    props.serviceOption
  );

  const { id, name, scoroProductId, price } = serviceOptionData;

  return (
    <SortableEntityTableRow entity={serviceOptionData} {...props}>
      <TableCell>
        <Link href={`/settings/service-options/${id}`}>{name}</Link>
      </TableCell>

      <TableCell center>{scoroProductId}</TableCell>

      <TableCell center>{price && `€${price}`}</TableCell>
    </SortableEntityTableRow>
  );
};

export default ServiceEditVariantsRow;
